import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import EventCard from './EventCard';
import { withRouter } from 'react-router-dom';
import { actions, Table, Pagination }  from 'react-data-components';
import 'react-data-components/css/table-twbs.css';
import MedienCarousel from './MedienCarousel';
import Autocomplete from './Autocomplete';
import DataTable from './Table/CustomDataTable';
import Header from './Header/index';
import TopPicks from './Picks';
import Collections from './Collections';
import Media from './Media';
import Footer from './footer';
import ExperienceCard from './ExperienceCard';
import './Styles/new-york.css';
import { API_BASE } from '../constant';
import Logo from './Images/pmp.png';
import PdfViewer from '../components/PdfViewer';
import { Typography, Divider, Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import { Image } from 'antd';

const columns = [
  { title: '', prop: 'image', render: (image) => <div className="city-card-img city-card-img--table" style={{ backgroundImage: `url(${image})` }}></div> },
  { title: 'Veranstaltung', prop: 'label', render : (label) => <span className="label">{label}</span> },
  { title: 'Datum', prop: 'date', sortable: true, render: (date) => {
  var date = new Date(date);

  // Extracting day, month, and year components
  var day = date.getDate();
  var month = date.getMonth() + 1; // Adding 1 as months are 0-based
  var year = date.getFullYear() - 2000; // Assuming you want to represen

  var formattedDate = (day > 9 ? day : ('0' + day)) + '.' +  (month > 9 ? month : ('0' + month))  + '.' + year;
  return <span>{formattedDate}</span> }},
  { title: 'R-Punkte', prop: 'points', render : (points) => <span className="points">{points}</span> },
];

const columnsExtended = [ ...columns,
  { title: 'ICW Zertifizierung', prop: 'ICW', render: (ICW) => <span>{ICW ? <i className="fa fa-check" aria-hidden="true"></i> : <i className="fa fa-times"></i>}</span> },
  { title: 'DGfw Zertifizierung', prop: 'DGfw', render: (ICW) => <span>{ICW ? <i className="fa fa-check" aria-hidden="true"></i> : <i className="fa fa-times"></i>}</span>  },
];


const keyMap = {
    VerordnungsfaehigkeitOderRezeptierbarkeit: "Verordnungsfähigkeit oder Rezeptierbarkeit",
    Unterpunkt1: "Produktgruppe",
    Unterpunkt2: "Produktspezifikation",
    IndikationOderErkrankung: "Indikation oder Erkrankung",
    Ernaehrungspumpe: "Ernährungspumpe",
    Nahrungsbehaeltnis: "Nahrungsbehältnis",
    stoma_type: "Stomaart",
    supply_system: "Versorgungssystem",
    baseplate_type: "Plattentyp",
    accessory_type: "Zubehör",
    is_accessory: "Zubehörprodukt",
}

const stomaValueLabels = {
  stoma_type: {
    colostoma: "Colostoma",
    ileostoma: "Ileostoma",
    urostoma: "Urostoma",
  },
  supply_system: {
    one_piece: "Einteilig",
    two_piece: "Zweiteilig",
    post_op: "Post-OP-Versorgung",
    pediatric: "Baby- & Kinderversorgung",
  },
  baseplate_type: {
    flat: "Plan",
    convex: "Konvex",
    convex_light: "Konvex (leicht)",
    "soft convex": "Soft convex",
    concave: "Konkav",
  },
  accessory_type: {
    skin_protection: "Hautschutz (Ringe, Pasten, Puder)",
    fixation: "Gürtel, Fixierungen, Bandagen",
    care_cleaning: "Pflege & Reinigung",
    hygiene_disposal: "Entsorgung & Hygiene",
    deodorant: "Geruchsneutralisation",
  },
};

const formatStomaValues = (values, key) => {
  const list = Array.isArray(values) ? values : [values];
  return list.map((value) => (stomaValueLabels[key] || {})[value] || value).join(", ");
};

class SelectableTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: '',
    };
  }

  selectRow = (row) => {
    this.setState({ selected: row.id });
  };

  deSelectRow = (row) => {
    this.setState({ selected: '' });
  };

  buildRowOptions = (row) => {
    return {
//      onMouseOver: () => this.selectRow(row),
//      onMouseOut: () => this.deSelectRow(row),
      className: this.state.selected === row.id ? 'active-row' : null,
    };
  };

  render() {
    return (
      <DataTable buildRowOptions={this.buildRowOptions} {...this.props} />
    );
  }
}

class Veranstaltung extends Component {
  constructor() {
    super()
    this.state = {
      lat: 51.505,
      lng: -0.09,
      zoom: 13,
      selected: ''
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  selectRow = (row) => {
    this.setState({ selected: row.id });
  }

//  buildRowOptions = (row) => { alert(row.name);
//   return {
//     onClick: this.selectRow.bind(this, row),
//     className: this.state.selected === row.id ? 'active' : null
//   }}

 formatDate = (date) => {
      var date = new Date(date);

      // Extracting day, month, and year components
      var day = date.getDate();
      var month = date.getMonth() + 1; // Adding 1 as months are 0-based
      var year = date.getFullYear() - 2000; // Assuming you want to represen

      var formattedDate = (day > 9 ? day : ('0' + day)) + '.' +  (month > 9 ? month : ('0' + month))  + '.' + year;
      return <span>{formattedDate}</span>
  }

  render() {

  const { veranstaltungenData, match } = this.props;
  const vId = match.params.id;

  const foundEntity = veranstaltungenData.find( v => v.id === +vId );


    return foundEntity ? (
      <>
  <CitySection
  style={{ marginTop: 46 }}
      key={1}
      headline={<h1 style={{ textAlign: 'left', fontWeight: 400, fontSize: 'inherit', margin: '0.83em 0 8px' }}>{foundEntity.Produktname}</h1>}
      description={<><EventCard type="produkt" foundEntity={foundEntity} API_BASE={API_BASE} />
        { ((foundEntity.Medien || {}).data || []).length > 0 && <MedienCarousel pickedData={foundEntity.Medien.data.map( el => el.attributes)} /> }
        { ((((foundEntity.Datenblaetter || {}).data  || {})[0] || {}).attributes) && <div>
        <Divider orientation="left">Datenblätter</Divider>
                    {((((foundEntity.Datenblaetter || {}).data  || {})[0] || {}).attributes) && <Col span={12}><PdfViewer  name={foundEntity.Datenblaetter.data[0].attributes.name} className={"leafImage leafImage--veranstaltung"} pdf={API_BASE + foundEntity.Datenblaetter.data[0].attributes.url}  /> </Col> }
                    </div> }
        { foundEntity.Produktbeschreibung && <div className="">
                    <Divider orientation="left">Produktbeschreibung</Divider>
                            <div className="edDrop" dangerouslySetInnerHTML={{ __html: foundEntity.Produktbeschreibung }} />

                            </div>}
        { foundEntity.Homepage && <p>
        {foundEntity.Homepage}
        </p>}
                <div style={{ padding: '20px', border: '1px solid #355fb3' }}>
                      <Divider orientation="left">Alle Informationen auf einen Blick</Divider>
                      <Row gutter={[24, 24]}>
                        <Col xs={24} sm={24}>
                          <Typography.Text><strong>Produktname:</strong> {foundEntity.Produktname}</Typography.Text>
                        </Col>
                        { foundEntity.PZN && <Col xs={24} sm={24}>
                          <Typography.Text><strong>PZN:</strong> {foundEntity.PZN}</Typography.Text>
                        </Col> }
                        {foundEntity.Hauptkategorie && <Col xs={24} sm={24}>
                          <Typography.Text><strong>Hauptkategorie:</strong> {foundEntity.Hauptkategorie}</Typography.Text>
                        </Col> }
                        {foundEntity.Unterkategorie && <Col xs={24} sm={24}>
                          <Typography.Text><strong>Unterkategorie:</strong> {foundEntity.Unterkategorie}</Typography.Text>
                        </Col> }
                        {foundEntity.Indikationen && <Col xs={24} sm={24}>
                          <Typography.Text><strong>Indikationen:</strong> {foundEntity.Indikationen}</Typography.Text>
                        </Col> }
                        {foundEntity.Kontraindikationen && <Col xs={24} sm={24}>
                          <Typography.Text><strong>Kontraindikationen:</strong> {foundEntity.Kontraindikationen}</Typography.Text>
                        </Col> }
                        {foundEntity.Anwendungshinweise && <Col xs={24} sm={24}>
                          <Typography.Text><strong>Anwendungshinweise:</strong> {foundEntity.Anwendungshinweise}</Typography.Text>
                        </Col> }
                        {(foundEntity.Produktgroesse && foundEntity.Produktgroesse.length > 0) && <h3 style={{ marginTop: 12, marginBottom: -6 }}> Produktgrößen zur Auswahl </h3>}
                        {foundEntity.Produktgroesse && foundEntity.Produktgroesse.map((groesse, index) => (
                          <Col xs={24} sm={24} key={index}>
                            <Typography.Text><strong>Größe :</strong> {groesse.GenaueGroesse}</Typography.Text>&nbsp;&nbsp;&nbsp;&nbsp;

                            <Typography.Text><strong>PZN:</strong> {groesse.PZN}</Typography.Text>
                          </Col>
                        ))}
                        {foundEntity.Produktgroesse && <Divider />}
                        {foundEntity.VerordnungsfaehigkeitOderRezeptierbarkeit && <Col xs={24} sm={24}>
                          <Typography.Text><strong>Verordnungsfähigkeit oder Rezeptierbarkeit:</strong> {foundEntity.VerordnungsfaehigkeitOderRezeptierbarkeit ? 'Ja' : 'Nein'}</Typography.Text>
                        </Col> }
                        {foundEntity.Risikoklassifizierung && <Col xs={24} sm={24}>
                          <Typography.Text><strong>Risikoklassifizierung:</strong> {foundEntity.Risikoklassifizierung}</Typography.Text>
                        </Col> }
                        {foundEntity.Wirkstoffhaltig && <Col xs={24} sm={24}>
                          <Typography.Text><strong>Wirkstoffhaltig:</strong> {foundEntity.Wirkstoffhaltig}</Typography.Text>
                        </Col> }
                        {foundEntity.Haftrand && <Col xs={24} sm={24}>
                          <Typography.Text><strong>Haftrand:</strong> {foundEntity.Haftrand}</Typography.Text>
                        </Col> }
                        {foundEntity.Kombination && <Col xs={24} sm={24}>
                          <Typography.Text><strong>Kombination:</strong> {foundEntity.Kombination}</Typography.Text>
                        </Col> }
                        {foundEntity.stoma_type && (foundEntity.stoma_type || []).length > 0 && <Col xs={24} sm={24}>
                          <Typography.Text><strong>{keyMap.stoma_type}:</strong> {formatStomaValues(foundEntity.stoma_type, "stoma_type")}</Typography.Text>
                        </Col> }
                        {foundEntity.supply_system && (foundEntity.supply_system || []).length > 0 && <Col xs={24} sm={24}>
                          <Typography.Text><strong>{keyMap.supply_system}:</strong> {formatStomaValues(foundEntity.supply_system, "supply_system")}</Typography.Text>
                        </Col> }
                        {foundEntity.baseplate_type && (foundEntity.baseplate_type || []).length > 0 && <Col xs={24} sm={24}>
                          <Typography.Text><strong>{keyMap.baseplate_type}:</strong> {formatStomaValues(foundEntity.baseplate_type, "baseplate_type")}</Typography.Text>
                        </Col> }
                        {foundEntity.accessory_type && (foundEntity.accessory_type || []).length > 0 && <Col xs={24} sm={24}>
                          <Typography.Text><strong>{keyMap.accessory_type}:</strong> {formatStomaValues(foundEntity.accessory_type, "accessory_type")}</Typography.Text>
                        </Col> }
                        {typeof foundEntity.is_accessory === "boolean" && <Col xs={24} sm={24}>
                          <Typography.Text><strong>{keyMap.is_accessory}:</strong> {foundEntity.is_accessory ? "Ja" : "Nein"}</Typography.Text>
                        </Col> }
                        {foundEntity.Unterpunkt1 && <Col xs={24} sm={24}>
                          <Typography.Text><strong>Produktgruppe:</strong> {foundEntity.Unterpunkt1}</Typography.Text>
                        </Col> }
                        {foundEntity.Unterpunkt2 && <Col xs={24} sm={24}>
                          <Typography.Text><strong>Produktspezifikation:</strong> {foundEntity.Unterpunkt2}</Typography.Text>
                        </Col> }
                        {foundEntity.Energiegehalt && <Col xs={24} sm={24}>
                          <Typography.Text><strong>Energiegehalt:</strong> {foundEntity.Energiegehalt}</Typography.Text>
                        </Col> }
                        {foundEntity.Verabreichungsart && <Col xs={24} sm={24}>
                          <Typography.Text><strong>Verabreichungsart:</strong> {foundEntity.Verabreichungsart}</Typography.Text>
                        </Col> }
                        {foundEntity.Exsudation && (foundEntity.Exsudation || []).length > 0 && <Col xs={24} sm={24}>
                          <Typography.Text><strong>Exsudation:</strong> {(foundEntity.Exsudation || []).join(", ")}</Typography.Text>
                        </Col> }

                        {foundEntity.Nahrungsbehaeltnis && <Col xs={24} sm={24}>
                          <Typography.Text><strong>Nahrungsbehaeltnis:</strong> {foundEntity.Nahrungsbehaeltnis}</Typography.Text>
                        </Col> }
                        {foundEntity.Ernaehrungspumpe && <Col xs={24} sm={24}>
                          <Typography.Text><strong>Ernaehrungspumpe:</strong> {foundEntity.Ernaehrungspumpe}</Typography.Text>
                        </Col> }

                        {foundEntity.ExternerLink && <Col xs={24} sm={24}>
                          <Typography.Text><strong>Weitere Informationen:</strong>

            <a target="_blank" href={foundEntity.ExternerLink} className="row external__link">{foundEntity.ExternerLink}</a>
            </Typography.Text>
                        </Col> }

                      </Row>
                    </div>
              </>
        }
    />
    <br />
      </>
    ) : <h2>Produkt nicht gefunden</h2>;
  }
}
//        <Media />
//        <Collections collectionsData={collectionsData} />
const CitySection = ({ style, headline, description, cardsData }) => (
  <div style={style} className="city-section-wrapper">
    <h2
      style={{
        textAlign: 'left', marginBottom: 8
      }}
    >
      {headline}
    </h2>
    <hr
      style={{
        backgroundColor: '#355fb3',
        width: '75px',
        height: '2px',
        border: 'none',
        marginTop: '0px',
        marginLeft: '0px',
        marginBottom: '10px'
      }}
    />
    <p
      style={{
        color: '#545454',
        fontSize: '15.3px',
        marginTop: '0px',
        textAlign: 'left',
        lineHeight: '20px'
      }}
    >
      {description}
    </p>
  </div>
);

export default withRouter(Veranstaltung);
